'use strict';

intellidealerAppPartsModule.config(['$stateProvider', function ($stateProvider) {
  $stateProvider.state(
    'navigation.parts.previousOrders.previousOnlineOrdersDetails', {
      url: '/previous-online-orders-details/{company}/{division}/{location}/{referenceNumber}' +
      '?previousOnlineOrdersDetailsPagination',
      params: {
        previousOnlineOrdersDetailsPagination: angular.toJson({
          sort: 'partNumber',
          direction: 'asc'
        })
      },
      views : {
        '@navigation.parts' : {
          templateUrl: 'app/scripts/modules/parts/views/previous-orders-details.html',
          controller: 'PreviousOrdersDetailsController'
        }
      },
      resolve: {
        breadcrumb: ['$stateParams', '$filter', function($stateParams, $filter) {
          return $filter('pathParam')($stateParams.referenceNumber);
        }],

        previousOrdersDetailsPagination: ['$stateParams', function($stateParams) {
          return angular.fromJson($stateParams.previousOnlineOrdersDetailsPagination);
        }],

        previousOrdersDetails: [
          'pageableService',
          'onlinePartsOrdersResource',
          'globalAlertService',
          '$stateParams',
          '$filter',
          'previousOrdersDetailsPagination',
          function(pageableService, onlinePartsOrdersResource, globalAlertService, $stateParams, $filter, previousOrdersDetailsPagination) {
            var parameters = {
              company: $stateParams.company,
              division: $stateParams.division,
              location: $stateParams.location,
              referenceNumber: $filter('pathParam')($stateParams.referenceNumber)
            };

            pageableService.addPageableParameters(
              parameters,
              previousOrdersDetailsPagination
            );

            return onlinePartsOrdersResource.assignedOnlineOrderDetails.get(
              parameters,
              function () {},
              globalAlertService.handleErrorResponse
            ).$promise;
          }
        ]
      }
    }
  );
}]);
